var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCohortDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 31,
    viewBox: "0 0 43 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.5C0 3.18629 2.68629 0.5 6 0.5H37C40.3137 0.5 43 3.18629 43 6.5V24.5C43 27.8137 40.3137 30.5 37 30.5H6C2.68629 30.5 0 27.8137 0 24.5V6.5Z",
    fill: "#EFEFFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.84074 11.5065H20.1741V12.8398H8.84074V11.5065ZM10.2574 8.83984H18.7574V10.1732H10.2574V8.83984ZM20.167 14.1665H8.83366C8.45794 14.1665 8.0976 14.307 7.83192 14.557C7.56625 14.8071 7.41699 15.1462 7.41699 15.4998V20.8332C7.41699 21.1868 7.56625 21.5259 7.83192 21.776C8.0976 22.026 8.45794 22.1665 8.83366 22.1665H20.167C20.5427 22.1665 20.9031 22.026 21.1687 21.776C21.4344 21.5259 21.5837 21.1868 21.5837 20.8332V15.4998C21.5837 15.1462 21.4344 14.8071 21.1687 14.557C20.9031 14.307 20.5427 14.1665 20.167 14.1665ZM13.2962 20.8332L10.9587 18.6732L11.9503 17.7398L13.2962 19.0065L17.0503 15.4732L18.042 16.4065L13.2962 20.8332Z",
    fill: "#5F5FFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3569 13.8459C36.3569 13.7049 36.3031 13.5638 36.1954 13.4564C35.9802 13.2411 35.6315 13.2411 35.4162 13.4564L32.4997 16.3737L29.5832 13.4564C29.368 13.2411 29.0193 13.2411 28.804 13.4564C28.5888 13.6716 28.5888 14.0203 28.804 14.2355L32.1102 17.5417C32.3254 17.7569 32.6741 17.7569 32.8894 17.5417L36.1955 14.2355C36.3035 14.1283 36.3569 13.9871 36.3569 13.8459Z",
    fill: "#7575A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCohortDropdown);
export default __webpack_public_path__ + "static/media/cohort-dropdown.f071b8e04d43f839708a4f4cba77af8d.svg";
export { ForwardRef as ReactComponent };